import { render } from "./TalkProjectComponent.vue?vue&type=template&id=13a9f19c&scoped=true"
import script from "./TalkProjectComponent.vue?vue&type=script&lang=js"
export * from "./TalkProjectComponent.vue?vue&type=script&lang=js"

import "./TalkProjectComponent.vue?vue&type=style&index=0&id=13a9f19c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a9f19c"]])

export default __exports__